import { GalleryFilter, useClientGallery } from '../_main/contexts'
import { useGalleryVisuals, useGalleryVisualsMeta } from '../../contexts'

import { ClientAssignmentReference } from 'components/pages/Property/ClientProperty/ClientAssignmentReference'
import { ClientGalleryFiltersDropdown } from '../ClientGalleryFiltersDropdown'
import { FC } from 'react'
import { GallerySection } from 'components/common/Gallery/GallerySection'
import Stack from '@mui/material/Stack'
import { useTranslation } from 'react-i18next'

/**
 * @interface Props
 */
interface Props {
  /** JSX elements that we render in section as unpurchased */
  unPurchasedVisuals: JSX.Element
}

/**
 * Client gallery photo section for not purchased visuals only.
 * 
 * @example <ClientGalleryPhotoSectionNotPurchasedAny />
 */
export const ClientGalleryPhotoSectionNotPurchasedAny: FC<Props> = ({ unPurchasedVisuals }) => {
  const { t } = useTranslation(['gallery'])

  const { favoritedVisuals } = useGalleryVisuals()
  const { filter } = useClientGallery()
  const {
    purchasedVisualsCount,
    unPurchasedVisualsCount,
    unPurchasedVisualsExist
  } = useGalleryVisualsMeta()

  return (
    <>
      <Stack
        flexDirection={{ xs: 'column', md: 'row' }}
        justifyContent={{ xs: 'flex-start', md: 'space-between' }}
        alignItems={{ xs: 'start', md: 'center' }}
        gap="1.5rem"
        sx={{
          marginBottom: '3rem',
        }}
      >
        <ClientAssignmentReference />

        <ClientGalleryFiltersDropdown hideTab={GalleryFilter.PURCHASED} />

      </Stack>

      {filter === GalleryFilter.ALL && unPurchasedVisualsExist &&
        <GallerySection
          title={t('visuals_ready')}
          subTitle={t('visuals_ready_description')}
        >
          {unPurchasedVisuals}
        </GallerySection>
      }

    </>
  )
}
